module.exports = __webpack_public_path__ + "static/media/btn_android_cn.70b84aa3.svg";